<template>
  <div class="board-standard">
    <div class="board-standard__label">Wyżywienie</div>
    <CheckList class="board-standard__body" :value="value" />
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import CheckList from '@/components/CheckList.vue'

@Component({
  components: {
    CheckList,
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
  },
})
export default class BoardStandard extends Vue {
}
</script>

<style lang="scss" scoped>
@import '../filter.scss';

.board-standard {
  @include filter(#005CAA);

  &__body {
    @include filter-body(#545454);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/search/fields/BoardStandardDropdown.vue